(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.routes')
		.config(routes);

	/** @ngInject */
	function routes($stateProvider, $locationProvider, PATHS, $urlRouterProvider) {
		$stateProvider
			.state('auth', {
				abstract: true,
				templateUrl: `${PATHS.PHYSICAL}/components/layout/layout.html`,
				onEnter: ($rootScope, $state, UserService, HelperService) => {
					var callback = () => {
						if (!UserService.isLogged()) {
							$state.go("app.login");
							return;
						}
					};

					$rootScope.hideLoading = true;
					callback();
				}
			})

			.state('auth.account', {
				title: 'Minha Conta',
				url: '/minha-conta',
				templateUrl: `${PATHS.PHYSICAL}/components/account/account.html`,
				controller: 'AccountController',
				controllerAs: 'vm'
			})
			.state('auth.my-rescues', {
				title: 'Meus Cupons',
				url: '/meus-cupons',
				templateUrl: `${PATHS.PHYSICAL}/components/my-rescues/my-rescues.html`,
				controller: 'MyRescuesController',
				controllerAs: 'vm'
			})

	}
}());